module.exports = __webpack_public_path__ + "8ea7a65ef62eec34311194b49971388c.svg";